module.exports = __webpack_public_path__ + "static/media/B18_page_04.2711ef3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/B18_page_04.mp4
// module id = v1qj
// module chunks = 0